import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { STORAGE_KEYS } from '../constants/storage.constants';

/**
 * Ensures OTP page is only accessible during an active verification session
 */
export const otpGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // If already logged in, redirect directly to dashboard / card-request
  if (authService.isAuthenticated()) {
    return router.createUrlTree(['/card-request']);
  }

  // Check if there is a pending verification session
  const hasPending =
    !!authService.pendingUserId() ||
    !!authService.pendingVerifyEmail() ||
    !!sessionStorage.getItem(STORAGE_KEYS.PENDING_USER_ID) ||
    !!sessionStorage.getItem(STORAGE_KEYS.PENDING_VERIFY_EMAIL);

  if (!hasPending) {
    return router.createUrlTree(['/auth/login']);
  }

  return true;
};
